// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__fnGxM","title":"BackImages_title__2m00O","images":"BackImages_images__1CJ3c"};